export const getDefaultState = () => {
  return {
    baseOnPrice: 'people',
    planDetail: null,
    customerPlan: null,
    isUseCoupon: false,
    isUseBenepoPoint: false,
    pointRemain: null,
    order: null,
    scrollCalendar: false
  }
}

const state = {
  baseOnPrice: 'people',
  planDetail: null,
  customerPlan: null,
  isUseCoupon: false,
  isUseBenepoPoint: false,
  pointRemain: null,
  order: null,
  scrollCalendar: false
}
export default state
